// extracted by mini-css-extract-plugin
module.exports = {"previewVideo":"PreviewVideoPlayer_previewVideo__1T_H6","previewController":"PreviewVideoPlayer_previewController__3I5IN"};